import { environment } from '../../../environments/environment';
export const fontsInitializer = () => {
  const fontSheet = new CSSStyleSheet();
  const fontIconSheet = new CSSStyleSheet();
  fontSheet.replaceSync(`
    
      @font-face {
        font-family: 'CIB Sans Bold';
        font-style: normal;
        font-weight: 400;
        src: url(${environment.assetsUrl}/fonts/CIBFontSans-Bold.ttf) format('truetype');
      }

      @font-face {
        font-family: 'CIB Sans';
        font-style: normal;
        font-weight: 400;
        src: url(${environment.assetsUrl}/fonts/CIBFontSans-Regular.ttf) format('truetype');
      }
      
      @font-face {
        font-family: 'CIB Sans Light';
        font-style: normal;
        font-weight: 200;
        src: url(${environment.assetsUrl}/fonts/CIBFontSans-Light.ttf) format('truetype');
      }

      @font-face{
        font-family:'Open Sans';
        src:url(${environment.assetsUrl}/fonts/OpenSans-Regular.ttf) format('opentype')
      }
      @font-face{
        font-family:'Open Sans Bold';
        src:url(${environment.assetsUrl}/fonts/OpenSans-Bold.ttf) format("opentype")
      }
      `);
  fontIconSheet.replaceSync(`
    @font-face {
        font-family: 'BC Icons';
        font-style: normal;
        font-weight: 400;
        src: url(${environment.assetsUrl}/fonts/icons.woff) format('woff');
    }
    `);

  document.adoptedStyleSheets.push(fontSheet);
  document.adoptedStyleSheets.push(fontIconSheet);
};
